<div flexLayout="row" style="margin-top: 20px;" fxLayoutAlign="center center" *ngIf="!loading">
    <div fxFlex="5">
        <mat-icon (click)="pageBack(endCursor);"
                  *ngIf="pageNumber > 0"
                  style="color: #8b8b8b; cursor: pointer; float: left;">arrow_back_ios</mat-icon>

        <mat-icon *ngIf="pageNumber < 1" style="color: #e6e6e6; float: left;">arrow_back_ios</mat-icon>
    </div>
    <div fxFlex="10" fxLayoutAlign="center center" style="font-size: 12px;">
        Items por pagina: <select [(ngModel)]="pageSize" (change)="changePageSize()" style="padding: 10px; margin-left: 5px;">
            <option *ngFor="let option of pageRanger" [value]="option">{{ option }}</option>
        </select>
    </div>
    <div fxFlex="5">
        <mat-icon (click)="pageNext(startCursor);"
                  *ngIf="hasNextPage || pageNumber == 0"
                  style="color: #8b8b8b; cursor: pointer; float: right;">arrow_forward_ios</mat-icon>

        <mat-icon *ngIf="!hasNextPage || pageNumber == 0" style="color: #e6e6e6; float: right;">arrow_forward_ios</mat-icon>
    </div>
</div>
